import React from 'react'
import ManageTrustedDevices from 'src/app/ManageTrustedDevices/ManageTrustedDevices'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { manageTrustedDevicesRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const ManageTrustedDevicesAppRoute: AppRoute = {
  id: AppLocation.ManageTrustedDevices,
  routeProps: manageTrustedDevicesRouteProps,
  component: <ManageTrustedDevices />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ManageTrustedDevicesAppRoute
